import React from 'react';
import {
    GroupRegistrationDataPage,
    GroupRegistrationDetailPage,
} from 'views/DashboardGroup';
import {
    SubmittedAbstract as SubmittedAbstractView,
    ApprovedAbstract as ApprovedAbstractView,
    SubmittedAbstractDetail as SubmittedAbstractDetailView,
    InvoiceList as InvoiceListView,
    InvoiceHotelList as InvoiceHotelListView,
    RegisterGroupListOperator as RegisterGroupListOperatorView,
    RejectedAbstract as RejectedAbstractView,
    PurchasedWorkshops as PurchasedWorkshopsView,
    PurchasedWorkshopDetail as PurchasedWorkshopDetailView,
    UserListOperator as UserListOperatorView,
    Registration as RegistrationView,
    OperatorDashboard as OperatorDashboardView,
    FinalScore as FinalScoreView,
    Checkin as CheckinView,
} from 'views/DashboardOperator';

const routes = [
    {
        path: '/dashboard/operator',
        element: <OperatorDashboardView />,
    },
    {
        path: '/dashboard/operator/submitted-abstract',
        element: <SubmittedAbstractView />,
    },
    {
        path: '/dashboard/operator/submitted-abstract/:id',
        element: <SubmittedAbstractDetailView />,
    },
    {
        path: '/dashboard/operator/final-score',
        element: <FinalScoreView />,
    },
    {
        path: '/dashboard/operator/registration',
        element: <RegistrationView />,
    },
    {
        path: '/dashboard/operator/checkin',
        element: <CheckinView />,
    },
    {
        path: '/dashboard/operator/approved-abstract',
        element: <ApprovedAbstractView />,
    },
    {
        path: '/dashboard/operator/rejected-abstract',
        element: <RejectedAbstractView />,
    },
    {
        path: '/dashboard/operator/invoice-list',
        element: <InvoiceListView />,
    },
    {
        path: '/dashboard/operator/invoice-hotel',
        element: <InvoiceHotelListView />,
    },
    {
        path: '/dashboard/operator/purchased-workshops',
        element: <PurchasedWorkshopsView />,
    },
    {
        path: '/dashboard/operator/purchased-workshops/:id',
        element: <PurchasedWorkshopDetailView />,
    },
    {
        path: '/dashboard/operator/register-group-list',
        element: <RegisterGroupListOperatorView />,
    },
    {
        path: '/dashboard/operator/user-list',
        element: <UserListOperatorView />,
    },
    {
        path: '/dashboard/group-registration-operator/:id',
        element: <GroupRegistrationDataPage />,
    },
    {
        path: '/dashboard/group-registration-detail-operator/:id',
        element: <GroupRegistrationDetailPage />,
    },
];

export default routes;
